// extracted by mini-css-extract-plugin
export default {"arrowLeft":"style_arrowLeft__Ag0ZJ","arrowRight":"style_arrowRight__UUWOY","arrowBottom":"style_arrowBottom__PCYmQ","arrowTop":"style_arrowTop__J-oqV"};